import { useEffect } from 'react';

import { useWebsocketPubSub } from '@queries/websockets';

const Ping = () => {
  const { subscribe, unsubscribe } = useWebsocketPubSub();

  useEffect(() => {
    const subscriptionId = subscribe({ topic: 'ping', options: {} }, () => {});
    return () => {
      unsubscribe(subscriptionId);
    };
    // NOTE: do not include subscribe/unsubscribe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Ping;
